'use client';

import { SlidersHorizontal } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer';

import { FiltersContent } from './filters-content';

type HeaderFiltersMobileProps = {
  filterCount: number;
  clearFilters: () => void;
  handleApplyFilters: () => void;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export const HeaderFiltersMobile = ({
  filterCount,
  clearFilters,
  handleApplyFilters,
  isOpen,
  setIsOpen,
}: HeaderFiltersMobileProps) => {
  return (
    <div className='flex flex-wrap items-center justify-between gap-2'>
      <Drawer autoFocus open={isOpen} onOpenChange={setIsOpen}>
        <DrawerTrigger asChild>
          <Button
            className='relative h-10 rounded-l-none rounded-r-xl border border-l-0 border-[#D1D1D1] hover:bg-brand-soft/25 focus-visible:ring-brand-green focus-visible:ring-offset-0'
            variant='ghost'
            size='icon'
          >
            <SlidersHorizontal className='text-brand-green' size={16} />
            {filterCount > 0 && (
              <Badge
                variant='filter-count'
                className='absolute -right-1 -top-1 bg-white'
              >
                {filterCount}
              </Badge>
            )}
          </Button>
        </DrawerTrigger>
        <DrawerContent className='max-h-[85vh]'>
          <DrawerHeader>
            <DrawerTitle className='py-0 text-start text-brand-dark'>
              Filters
              {filterCount > 0 && (
                <span className='ml-2 text-sm text-muted-foreground'>
                  ({filterCount})
                </span>
              )}
            </DrawerTitle>
            <DrawerDescription className='sr-only'>
              Select the filters you want to apply to your search.
            </DrawerDescription>
          </DrawerHeader>

          <FiltersContent className='px-4' variant='mobile' />

          <DrawerFooter className='border-t'>
            <div className='flex gap-2'>
              <Button
                onClick={clearFilters}
                variant='secondary'
                className='flex-1'
              >
                Reset All
              </Button>
              <Button onClick={handleApplyFilters} className='flex-1'>
                Apply Filters
              </Button>
            </div>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </div>
  );
};
